<davinci-button class="button" [type]="type" [icon]="icon" [disabled]="disabled" click="clicked()">{{ label }}</davinci-button>
